import { Checkbox, Input, Modal } from '@lib/components'
import { Button } from '@octopus-do/octopus-storybook'
import cx from 'classnames'
import type React from 'react'

import { API_KEY_SCOPES } from '@/components/Dashboard/pages/ApiKeys/constants'
import type { ModalProps } from '@/types'
import { useCreateApiKey } from './hooks/useCreateApiKey'
import css from './styles.module.scss'

export const CreateApiKey: React.FC<ModalProps> = ({ onClose }) => {
  const { scope, error, loading, changeName, changeScope, create } =
    useCreateApiKey()

  return (
    <Modal
      classnames={{ content: css.modal, body: css.body }}
      onClose={onClose}
    >
      <div className={css.container}>
        <div className={css.title}>Create API key</div>

        <Input
          label="Key name"
          id="apiKeyName"
          name="apiKeyName"
          type="normal"
          placeholder="e.g. CI bot"
          onChange={changeName}
        />

        <div className={css.section}>
          <div className={css.section_title}>Scopes</div>

          <div className={css.scopes}>
            {API_KEY_SCOPES.map(({ value, label }) => (
              <Checkbox
                key={value}
                label={label}
                checked={scope === value}
                classnames={{
                  container: cx(
                    css.scope_row,
                    scope === value && css.scope_row_selected
                  ),
                  input: css.scope_input,
                }}
                onChange={() => changeScope(value)}
              />
            ))}
          </div>
        </div>

        {error && <div className={css.error}>{error}</div>}
      </div>

      <Button
        className={css.wide_button}
        label="Create key"
        loading={loading}
        onClick={create}
      />
    </Modal>
  )
}
